import axios from "@/api/axios";

export async function createOffice({ cityId, cityName, officeName }) {
  const { data } = await axios.post(`/offices`, { cityId, cityName, officeName });
  return data;
}

export async function updateOffice(id, { officeName }) {
  const { data } = await axios.patch(`/offices/${id}`, { officeName });
  return data;
}

export async function setOfficeEnable(id, isEnable) {
  const { data } = await axios.patch(`/offices/enables/${id}`, { isEnable });
  return data;
}

export async function setOfficeOperation(id, inOperation) {
  const payload = {
    isEnable: inOperation,
    officeStatus: inOperation ? "available" : "retired",
  };
  const { data } = await axios.patch(`/offices/enables/${id}`, payload);
  return data;
}
